export const REQUEST_TYPE = {
  APPROVAL: 1,
  COPYRIGHT: 2,
} as const

export const DISTRIBUTION_METHOD = {
  PRINT_ONLY: 1,
  DIGITAL_ONLY: 2,
  BOTH: 3,
} as const

/** The kinds of licence the cart sells; a request is one of them and nothing else. */
export const CART_ITEM_TYPE = {
  ARRANGEMENT_SONGBOOK: 1,
  LYRICS_ONLY: 2,
  ACADEMIC_TEXTBOOK: 3,
  DISSERTATION: 4,
  BULLETIN_PROGRAM: 5,
  PHOTOCOPY: 6,
  ARRANGEMENT: 7,
  RECORD: 8,
  BROADCAST_SYNC: 9,
  RECORDING: 10,
  TEMPORARY_POST: 11,
  OTHER: 12,
} as const

/** The kinds that state a publication, and so read as one card in the panels. */
export const PUBLICATION_CART_ITEM_TYPES: number[] = [
  CART_ITEM_TYPE.ARRANGEMENT_SONGBOOK,
  CART_ITEM_TYPE.ACADEMIC_TEXTBOOK,
]

export const CartLyricsOnlyDistributionMethod = {
  PHYSICAL_PRINT: 1,
  EBOOK: 2,
  AUDIO_BOOK: 3,

  displayName(method: number | null | undefined): string {
    switch (method) {
      case this.PHYSICAL_PRINT:
        return 'Physical Print'
      case this.EBOOK:
        return 'E-book'
      case this.AUDIO_BOOK:
        return 'Audio Book'
      default:
        return '—'
    }
  },
} as const

export const CartPublicationDistributionMethod = {
  PHYSICAL_PRINT: 1,
  EBOOK: 2,
  PRINTED_AND_DIGITAL: 3,

  displayName(method: number | null | undefined): string | null {
    switch (method) {
      case this.PHYSICAL_PRINT:
        return 'Physical Print'
      case this.EBOOK:
        return 'E-book'
      case this.PRINTED_AND_DIGITAL:
        return 'Printed and Digital'
      default:
        return null
    }
  },
} as const

type TDistributionLine = {
  cartItemTypeId: number
  productType: number | null
  distributionMethod: number | null
}

export const distributionLineName = (line: TDistributionLine): string | null =>
  line.cartItemTypeId === CART_ITEM_TYPE.LYRICS_ONLY
    ? CartLyricsOnlyDistributionMethod.displayName(line.productType ?? line.distributionMethod)
    : CartPublicationDistributionMethod.displayName(line.distributionMethod ?? line.productType)

export const PublisherApproveRequestStatus = {
  NEW: 1,
  APPROVED: 2,
  PARTIALLY_APPROVED: 3,
  REJECTED: 4,
  PENDING_REVIEW: 5,
  IN_PROGRESS: 6,
} as const

export const PublisherRequestTypeEnum = {
  APPROVAL_REQUEST: 1,
  COPYRIGHT_REQUEST: 2,
  LYRICS_APPROVAL_REQUEST: 3,
  COMMON_APPROVAL_REQUEST: 4,

  displayName(method: number | null | undefined): string {
    switch (method) {
      case this.APPROVAL_REQUEST:
        return 'Approval Request'
      case this.COPYRIGHT_REQUEST:
        return 'Copyright Request'
      case this.LYRICS_APPROVAL_REQUEST:
        return 'Lyrics Approval Request'
      case this.COMMON_APPROVAL_REQUEST:
        return 'Approval Request (common)'
      default:
        return 'Unknown'
    }
  },
} as const

export const SongFeeCounterOfferType = {
  PRINT: 1,
  DIGITAL: 2,
  LYRICS: 3,

  displayName(type: number | null | undefined): string {
    switch (type) {
      case this.PRINT:
        return 'Print'
      case this.DIGITAL:
        return 'Digital'
      case this.LYRICS:
        return 'Lyrics'
      default:
        return 'Unknown'
    }
  },
} as const
